export enum UploadTypeEnum {
  upload = 'upload',
  uploadAfterDisable = 'uploadAfterDisable'
}
